import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoveUp = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9 7V2",
			stroke: "#D9DEEB",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 4L9 2L11.5 4",
			stroke: "#D9DEEB",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.3913 10H2.6087C2.27252 10 2 10.3838 2 10.8571V15.1429C2 15.6162 2.27252 16 2.6087 16H15.3913C15.7275 16 16 15.6162 16 15.1429V10.8571C16 10.3838 15.7275 10 15.3913 10Z",
			stroke: "#D9DEEB",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgMoveUp);
export default ForwardRef;
